module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0020-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("By December 1943, the Allies had decided to mount an amphibious landing behind the German lines to turn the enemy defence. The spot chosen was Anzio, 50 miles north of the Gustav Line and 30 miles south-east of Rome, the landing to be carried out by the US VI Corps. The date planned for the operation was January 22, 1944. To prevent the Germans from being able to withdraw forces from the main front to counter the landing, and to force them to commit their reserves, Clark’s Fifth Army was to engage in a strong blow-by-blow attack on the Gustav Line by all its three corps in turn. Once the French Expeditionary Corps and US II Corps had reached the line of the Rapido and Gari rivers and drawn abreast with British X Corps, already lined up along the Garigliano further south, the X Corps would start off the attack with an assault across the river. Then the US II Corps would follow with an assault across the Rapido, and the French would deliver the next blow by continuing their drive across the upper part of the river and into the mountains north of Cassino. It was hoped a breakthrough into the Liri valley would lead to a speedy link-up between Fifth Army’s main force and the US VI Corps advancing from the Anzio bridgehead.")])])]), _vm._v(" "), _c('h3', {
    staticClass: "chtit",
    attrs: {
      "id": "ch"
    }
  }, [_vm._v("Cassino")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fred Majdalany fought in North Africa, Sicily and Italy and was wounded and awarded the Military Cross. He took part in the battle for Cassino as a company commander with the 2nd Lancashire Fusiliers (78th Division) and in 1957 set down his masterly account in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cassino: Portrait of a Battle.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘At the beginning of January, when the Eighth Army had run into a dead end on the narrow Adriatic front and the Fifth had at last battered its way to the edge of the valley approach to Cassino — to be rewarded by the sight of yet another natural obstacle more formidable than anything it had so far experienced — a natural break in the progress of the campaign had been reached.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It was not through any exceptional tactical percipience that the Germans chose Cassino as the hard core of their main defence line. It was already well known. Truthfully the German commander might have said, “I got it from a book”. For many years the Italian Military College had held it up to students as an example of an impregnable natural defence barrier. Generations of officers had fought imaginary battles of Cassino as a part of their military studies. Had the Allied commanders happened to ask an Italian senior officer where he thought the Germans would be most likely to make a stand south of Rome, he would have replied without hesitation: “Why, at Cassino, of course”. It is not on record whether any responsible Italian military men were so consulted. On the whole it seems unlikely as there appears to have been no awareness among the higher Allied echelons that Cassino might prove any more difficult than what had gone before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The defence of this sector had been entrusted to the XIV. Panzerkorps of 10. Armee commanded by General von Senger und Etterlin. The essence of the position was its situation of a steep mountain massif towering above the angle made by two wide valleys meeting at right angles. To enter the Liri valley (along which the road to Rome passes) it was necessary to cross the Rapido valley with which it formed an L. Monte Cassino, in the angle of the L, commanded the approach across the first valley, and the entrance to the second. If a force managed to break directly into the second valley away from the immediate vicinity of Cassino, it would still be overlooked at every stage of its progress. That was the heart of the matter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Monte Cassino and the adjacent heights completely controlled the approach to Cassino and the route past it. From the summit of Monte Cassino an observer could watch every move in either valley. Even in moonlight it is possible from this vantage point to pick out the shapes of hills four miles or more away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It may be as well to make it clear at this point that when we speak of commanding heights — and in any account"), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v(" of the Italian campaign the phrase recurs on every page — it does not necessarily mean that soldiers must sit on them to make them so. Heights are commanding because of the observation they afford. Observation is the key to the modern land battle. The combination of modern gunnery techniques and wireless communication means that one man — quite literally one man — with a good view and a wireless set can direct the guns of an entire army within a few minutes on to any target he can see. The seizing of a dominant height is not undertaken merely in order that it may be garrisoned, but primarily in order that an observation post may be established on it. A modern campaign is largely a progress from one desirable line of observation to another.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("However, as the Allied troops fighting to get clear of the mountains that had slowed their advance to a frustrating crawl during the bleak and harsh winter months reached points from where they could see the terrain ahead, they had their first glimpse of the mountain feature that stood as a towering sentinel guarding the road to Rome. This feature would become the focus of all their efforts over the next five months: the Monte Cassino, crowned by the massive mediaeval abbey of the same name, with the town of Cassino spread out at its base.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("With a population of about 25,000 before the war, Cassino was a rather pleasant town, also a regional market centre, with some popular tourist attractions and offering a convenient break in travels from Rome to Naples. The town had a history dating back to before Roman times. After their defeat of the Sabini in the 4th century BC, the Volsci established a settlement at the base of the Monte Cairo massif and called it Casinum. It came under control of the Samnites in 321 BC but fell to the Romans in 313 BC, who established a colony there. It remained theirs until it was sacked by the Goths in 494 AD. The town that eventually developed on the site of ancient Casinum was known for centuries as San Germano, but on July 28, 1863, the name was officially reverted to ‘Cassino’. This pre-war view is looking down Via Principe Umberto. The church on the left is the Chiesa di Sant’Antonio.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The same view down what is today the Corso della Repubblica. The rebuilt church incorporates parts of the original.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0022-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The layout of Cassino was largely determined by the line of Route 6 (the old Roman Via Casilina), which was the main road from Naples to Rome that passed through the municipality.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Conversely, having picked out a height on which the enemy will obviously have established observation posts, it becomes necessary to do everything possible to make such posts untenable, by shelling and bombing them and generally making the practice of observation as unpleasant as possible. If some feature such as a water tower or a church steeple presents itself as a vantage point likely to be used by the enemy, it will be necessary to try to destroy it. If a vantage point on a hill feature is proving particularly tiresome as an enemy observation post, it may be necessary to mount a brigade or even a divisional attack against it merely to deprive the enemy of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The importance of observation is stressed because every soldier who ever sees Monte Cassino at once recognizes it to be just about the finest natural observation post he has ever encountered. This is a key matter in the battle of Cassino, and one which has a considerable bearing on subsequent events.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The decision to defend the Cassino line having been made when the Fifth Army was still 60 miles away, General von Senger could set about improving on this natural defence barrier methodically.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He blasted emplacements in the solid rock of the mountains. Natural caves were enlarged and adapted to house guns and men. Artificial caves were created and camouflaged to conform with the appearance of the mountainside. Machine-gun nests were constructed behind rocky outcrops, so that they had concealment, protection, and good lines of fire. The zig-zag road up the eastern face of Monte Cassino began to bristle with gun positions, as did the heights which crowd in on the mountain on its northern and western sides. In the deep ravines which run between these ridges and crests mortar emplacements were constructed — for mortars fire at a steep angle and can therefore be hidden away in deep gullies from which they can fire without much danger of being hit back. On the mountainsides the stiff gorse thickets were laced with barbed wire and sown with mines. Approaches to all prepared posts were guarded by trip wires that would set off flares or mines or both.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0023-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("As the road entered the town from the south, the highway divided into two main streets — the Via Principe Umberto on the left (south) and Corso Vittorio Emanuele II on the right (north) — which ran in straight lines but diverging from each other for about a kilometre until both reached the perpendicular street at the foot of the mountain. Route 6 then continued on its way by making a left turn and exiting the town towards Rome. This oblique aerial photograph, taken by an Allied reconnaissance aircraft on November 26, 1943, gives a perfect view of the town as it was before violence and destruction was meted out in the forthcoming battles. We have marked the most important buildings and features. Most of them would become notorious landmarks during the later fighting. [1] Hotel des Roses; [2] Hotel Excelsior (Continental); [3] Piazza Ciano; [4] Rocca Ianula (Castle Hill); [5] Chiesa di Sant’Antonio; [6] Piazza Principe Amedeo (Botanical Gardens); [7] Municipio (Municipal Buildings); [8] Chiesa del Carmine (The Convent, later The Crypt; [9] Chiesa di Santa Scholastica (The Nunnery).")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0023-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Via Napoli or Corso Vittorio Emanuele II — the north leg of Route 6 — looking into town, with Castle Hill towering above the built-up area. The large building on the left is the Palazzo Notarmarco, while to the right can be seen the town’s Campanile, or bell tower.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0023-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Corso Vittorio Emanuele has since been re-named the Via Enrico de Nicola. Completely flattened during the 1944 battle, the Palazzo Notarmarco has been replaced by an equally substantial building. Just off to the left is the Cassino war memorial.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("‘In the valley both sides of the Rapido were heavily mined, and more trip wires were laid. Gun positions were buried in the banks on the enemy side of the river, and in the ditches, and mounds, and hummocks which are numerous at the entrance to the Liri valley. Farm buildings were fortified, pillboxes and tank turrets were ingeniously submerged in the ground and camouflaged so that they were invisible. All these positions were most carefully constructed and reinforced with steel and concrete so that they would resist the great artillery concentrations which always preceded the Allied attacks. The Germans were used to them by this time and determined to endure them in security if not comfort. In fact the Allied troops were repeatedly disappointed to discover afterwards how relatively little damage even their heaviest barrages inflicted — so skilled had the Germans become at constructing positions that would afford them protection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Cassino town was heavily fortified. Buildings were turned into strong-points. Cellars and ground floors were reinforced. Tanks were concealed inside some of the larger buildings. Tunnels and connecting trenches were constructed between a cellar strong point on one side of the road and a shelter on the other. Many buildings, strong in themselves, were made stronger by the inclusion of a bunker or pillbox inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘To the north of the town, where the Rapido has its source, they dammed it and created diversions so that when the heavy rains came the whole valley was turned into an area of flood and marsh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The work went on day after day while the rearguards kept the Fifth Army at bay, playing for time, weakening the advancing troops, tiring them, making them fight for every yard of ground. For three months the XIV. Panzerkorps worked at these defences and to help them they had a large detachment of the Todt Labour Organization.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘They did not at this time enter the Monastery itself. An army order had placed it out of bounds and a military policeman saw that this was enforced. But they were all round it, on the heights close by, and along the zig-zag road, and near the crest of the mountain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘This was Cassino — the hard core of what the Germans called the Gustav Line — a natural mountain barrier made infinitely stronger by the ingenuity of military engineers: a natural river barrier made infinitely stronger by steel and concrete fortifications and artificial flooding of the wide valley approaches.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0024-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Town plan of Cassino as it was before the war. [1] Colosseum (Roman circus); [2] Railway engine shed (The Round House); [3] Railway Station; [4] Funivia (cable-car) to Monastery Hill; [5] Chiesa del Carmine (The Convent, also The Crypt); [6] Municipio (Municipal Buildings); [7] Post Office; [8] Nuovo Stirpe square; [9] Palazzo Notarmarco; [10] Chiesa di Sant’Antonio; [11] Piazza Principe Amedeo (Botanical Gardens); [12] Hotel des Roses; [13] Hotel Excelsior (Continental); [14] Palazzo Bruno; [15] Piazza Ciano; [16] Rocca Ianula (Castle Hill); [17] Chiesa di Santa Scholastica (The Nunnery); [18] Jail.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0025-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cassino’s central square was the Piazza Umberto I, located just north of the Via Napoli. Bounded on one side by the Duomo (Cathedral), or Chiesa Maggiore, and by the Tribunale (Court-house) on another, it was also the spiritual and legal centre.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0025-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The replacement cathedral is of a modern design, but in the same place as the original one. The surrounding area was left open in the post-war reconstruction and no longer has the maze of mediaeval streets that existed until 1944.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0025-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Via Principe Umberto — the south leg of Route 6 — as it looked at the turn of the century, with Via Arigni to the left, Via Rapido to the right, and the monastery overlooking all from its lofty position.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0025-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Now the Corso della Repubblica, still with Via Arigni to the left, but Via Rapido on the right has been renamed Via Guglielmo Marconi.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘At the beginning of January, when the Eighth Army had run into a dead end on the narrow Adriatic front and the Fifth had at last battered its way to the edge of the valley approach to Cassino — to be rewarded by the sight of yet another natural obstacle more formidable than anything it had so far experienced — a natural break in the progress of the campaign had been reached.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It was not only desirable that the tired Fifth should stop to lick its wounds, reorganize, and rest, but it was essential. It had been fighting, almost without pause, for four months. It had had to contend not only with country which entirely favoured the defender, but also with exceptional extremes of winter weather. Wet and frozen, continuously in action, these men had known nothing but mud and mountain for weeks. Sickness brought on by too much exposure to wet and cold was claiming as many casualties as wounds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now they had reached the bend in the road. Looking across the great valley to Cassino they knew that they faced a barrier more powerful than anything they had yet tackled — and they had tackled a few by this time. It was essential that there should be a pause and a short rest — if only so that the next move could be properly thought out, prepared, and launched. But there was no pause.’")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0025-5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("At the point where Via Principe Umberto met up with the street running at right angles (and where Route 6 swung south and out of town) lay the Piazza Galeazzo Ciano. It was surrounded by several nice palazzi, one of which, the Palazzo Danese, housed a comfortable tourist accommodation, the Excelsior Hotel-Restaurant-Garage. It would become one of the main German strongholds during the battle, better known by Commonwealth troops as the Continental Hotel. Just visible on the right is the Palazzo Bruno, another German bastion throughout the fighting. (A palazzo in Italian indicates a large building rather than a palace so, for example, the Palazzo Danese was the property owned by the Danese family.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0025-6.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Today the space that carried the name of Mussolini’s son-in-law and foreign minister is no longer a square. Both the Hotel Excelsior and the Palazzo Bruno have been replaced by new buildings.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Looking south from Piazza Ciano down Corso Vittorio Emanuele II (now with the Hotel Excelsior on the right) were several other palazzi that were to play a prominent role as German strongpoints in the coming battles: on the right, immediately adjoining the Excelsior, the Palazzo Iucci; opposite this the Palazzo Silvestri; and further down, on the right, the Palazzo Collela (better known as the Hotel des Roses).")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The same view today. Palazzo Silvestri and its neighbour were rebuilt further back, the post-war planners taking the opportunity to widen Route 6. Traffic on the highway’s two branches through the town is today one-way and this corner is where the change occurs.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("View from the Palazzo Collela (Hotel des Roses) looking back towards the Piazza Ciano. Dating back to the beginning of the 1800s, this palazzo served for a time as the home of the Baron de Rosa who moved to Cassino from Naples around the end of the 19th century. Responsible for the construction of the railway, he used it for a time as a hostel for his railway workers, hence it appeared on some old maps as the Albergo delle Rose (Roses Inn) although it was never a hotel as such. He eventually returned to Naples and sold it to the Collela and Martire families. Thus it is also sometimes referred to as the Palazzo del Cavaliera A. Martire.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Despite the almost complete destruction of the Hotel des Roses during the battle, the rebuilt edifice is quite faithful to the original plans. Many of the lower heavy stone walls survived under the rubble from upper stories, so it was possible to build on these foundations.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("At the south-eastern end of town, branching off southwards from Corso Vittorio Emanuele II (Route 6), was Viale Dante which ran in a straight line to Cassino’s railway station. This is the view from the Palazzo Notarmarco, with the Municipio (Town Hall) on the left and — across Via Principe Umberto (the south leg of Route 6) — the Chiesa di Sant’Antonio on the right. The green in front of the Town Hall, featuring the ornamental fountain, was known as the Nuovo Stirpe and the tree-lined square on the right was the Piazza Principe Amedeo (which would become known as ‘The Botanical Gardens’ during the battle).")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-6.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Before the war Viale Dante ran through open farmland to the station but today it is a main road in the new town, the post-war reconstruction having lined it with nondescript buildings.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cassino’s railway station. Positioned halfway between Naples and Rome, the town was an important railway stop with large marshalling yards and a big locomotive shed (which would become known as ‘The Round House’ during the battle) on the southern side of it. In this view from the 1920s, Monte Trocchio rises up behind the station.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("With the original being completely ruined during the battle, this is the station’s present-day replacement.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Directly across the street from the railway station stood the lower terminus of the Funivia (cable-car) which visitors could use to travel speedily and easily up the mountain to reach the monastery. Today this site is occupied by a large apartment block and shopping centre which now completely masks the mountain.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("During its journey up and down, the cable-car was supported by a stanchion on an outcrop hill (named Monte Venere after the god Venus), which can be seen in the distance. During the upcoming battle, this crag would gain notoriety as ‘Hangman’s Hill’.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The cable-car was not rebuilt after the war although plans to reinstate it have resurfaced at regular intervals since then, the most recent scheme being from 2008.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0028-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The other promontory rising in front of Monastery Hill was the Colle Ianula (which was named after the god Janus) or, to give its better-known name during the battle, Castle Hill. The fortification built on its peak was called the Rocca (Fortress) Ianula. This had been established in the second half of the 10th century by Abbot Aligerno to protect the citizens in the town below but the German Emperor Frederick II ordered its demolition in 1226. However, it was rebuilt and survived intact until 1944. Below the hill lay a complex of religious buildings including the church and monastery of Santa Scholastica (named after the twin sister of St Benedict). This would become known as ‘The Nunnery’ during the battle.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0028-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Towering above it all — as a lofty guardian of the town, a fortress dominating the entire surrounding area — was the Benedictine abbey sitting on the 516-metre-high summit of Monte Cassino. This is the view from the north-west.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0028-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Today Monastery Hill is covered with trees and there are only a few places from which a comparison can be made.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A world-renowned centre of religious culture and learning, the abbey had a long and stormy history. Founded by St Benedict of Nursia in 529 AD, it was the first monastery of the Benedictine Order. Having previously established a number of small communities of monks in Subiaco, Benedict moved to Cassino with a band of followers to escape the persecution of a jealous priest, founding the first large community of the new monastic order. Demolishing the ruins of a pagan temple of Apollo that occupied a part of the summit, and incorporating an old Roman tower, Benedict built a first monastery but this was sacked and destroyed in 583, 40 years after Benedict’s death, by marauding bands of Lombards who wanted to use it as a stronghold against the Roman duchy. The surviving monks fled to Rome. The monastery was not rebuilt until 718, by Abbot Petronax of Brescia, and this time it survived for nearly two centuries, until 883, when it was again overwhelmed, this time by the Saracens who burnt it to the ground. Restoration was begun two years later, 70 years passing before it was completed. During its third lease of life, the abbey not only became a centre of worship, learning and culture, its monks contributing uniquely to Western civilization by transcribing and thus passing on the great works of ancient Greek and Roman literature, but also gained great economic prosperity and political influence, its estates in the surrounding valleys increasing to a formidable 250,000 acres and the abbots becoming powerful landlords as well as spiritual leaders. The great Abbot Desiderius (1058-87) extensively rebuilt the abbey, adding lavish decorations and building a magnificent cathedral within its walls. Disaster struck again in 1349 when the abbey was wrecked in a tremendous earthquake but rebuilding began immediately and, with the support of Pope Urban V, a massive structure based around five cloistered courtyards was completed before the end of the century. Although the high tide of the Benedictines’ power was over, this building, apart from being sacked by Napoleon’s troops in 1799, would survive intact for the next 500 years – until 1944.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Built in the form of a trapezium, the monastery was a four-storied building with a thick battlemented base and long even rows of cell windows. It included a basilica, a seminary, a college for boys, a great library that ran nearly the full length of the building, as well as workshops, a kitchen garden and a large building to house the animals required for food. It was a complete self-contained community, able to subsist by itself, and approachable only by an eight-kilometre-long hairpin track.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A sublime example of the abbey’s splendid architecture was the famous Bramante Cloister. Designed by the eminent Renaissance architect Donato Bramante (1444-1514) and completed in 1595, this spacious courtyard was renowned for its colonnaded octagonal well in the centre and the flight of steps, flanked by statues, linking it to the anti-portico of the upper Benefactors Cloister. Its western balcony offered a beautiful view of the Liri valley.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Virtually unchanged through the mist and rain.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4613fd1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Chapter2.vue
// module id = 87
// module chunks = 0